// diagnosticReportSlice.js
import { createSlice } from "@reduxjs/toolkit";

const diagnosticReportSlice = createSlice({
    name: "diagnosticReports",
    initialState: {},
    reducers: {
        registerDiagnosticReport: (state, action) => {
            const dr = action.payload;
            if (!dr?.id) return;

            if (!state[dr.id]) {
                state[dr.id] = dr;
            } else {
                console.warn(
                    `⚠️ DiagnosticReport ${dr.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterDiagnosticReports: (state, action) => {
            action.payload.forEach((dr) => {
                if (!dr?.id) return;

                if (!state[dr.id]) {
                    state[dr.id] = dr;
                } else {
                    console.warn(
                        `⚠️ DiagnosticReport ${dr.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const { 
    registerDiagnosticReport, 
    bulkRegisterDiagnosticReports 
} = diagnosticReportSlice.actions;

export default diagnosticReportSlice.reducer;
